import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { AnalyticsTopResultsActivityLoadAction } from '../../domains/analyticsTopResultsActivity/actions.types';
import { CampaignTopContentCreatorsLoadFulfilledAction } from '../../domains/campaignTopContentCreators/actions.types';
import { CampaignTopThreadSourcesLoadFulfilledAction } from '../../domains/campaignTopThreadSources/actions.types';
import { CampaignTopThreadsLoadFulfilledAction } from '../../domains/campaignTopThreads/actions.types';
import { EmployeesTopThreadsLoadFulfilledAction } from '../../domains/employeesTopThreads/actions.types';
import { LeadershipThemeTopThreadsLoadFulfilledAction } from '../../domains/leadershipThemeTopThreads/actions.types';
import { NetworkThemeTopThreadsLoadFulfilledAction } from '../../domains/networkThemeTopThreads/actions.types';
import { NetworkTopAnnouncementsLoadFulfilledAction } from '../../domains/networkTopAnnouncements/actions.types';
import { NetworkTopGroupsLoadFulfilledAction } from '../../domains/networkTopGroups/actions.types';
import { NetworkTopThemesLoadFulfilledAction } from '../../domains/networkTopThemes/actions.types';
import { NetworkTopThreadStartersLoadFulfilledAction } from '../../domains/networkTopThreadStarters/actions.types';
import { NetworkTopThreadsLoadFulfilledAction } from '../../domains/networkTopThreads/actions.types';
import { QuestionsViewersEngagedLoadFulfilledAction } from '../../domains/questionsViewersEngaged/actions.types';
import { ThreadExtendedActivitySharesLoadFulfilledAction } from '../../domains/threadExtendedActivityShares/actions.types';
import { ThreadExtendedActivityTopRepliesLoadFulfilledAction } from '../../domains/threadExtendedActivityTopReplies/actions.types';
import { ViewerTopRepliesLoadFulfilledAction } from '../../domains/viewerTopReplies/actions.types';
import { ViewerTopThreadsLoadFulfilledAction } from '../../domains/viewerTopThreads/actions.types';

import { AnalyticsTopResultsEntitiesLifecycle } from './types';

export type AnalyticsTopResultsAction =
  | AnalyticsTopResultsActivityLoadAction
  | EmployeesTopThreadsLoadFulfilledAction
  | QuestionsViewersEngagedLoadFulfilledAction
  | ViewerTopRepliesLoadFulfilledAction
  | ViewerTopThreadsLoadFulfilledAction
  | CampaignTopThreadsLoadFulfilledAction
  | CampaignTopThreadSourcesLoadFulfilledAction
  | CampaignTopContentCreatorsLoadFulfilledAction
  | LeadershipThemeTopThreadsLoadFulfilledAction
  | NetworkTopThreadStartersLoadFulfilledAction
  | NetworkTopThemesLoadFulfilledAction
  | NetworkTopGroupsLoadFulfilledAction
  | NetworkThemeTopThreadsLoadFulfilledAction
  | NetworkTopAnnouncementsLoadFulfilledAction
  | NetworkTopThreadsLoadFulfilledAction
  | ThreadExtendedActivityTopRepliesLoadFulfilledAction
  | ThreadExtendedActivitySharesLoadFulfilledAction;

const initialState: AnalyticsTopResultsEntitiesLifecycle = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<AnalyticsTopResultsEntitiesLifecycle, AnalyticsTopResultsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'EMPLOYEES_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'QUESTIONS_VIEWERS_ENGAGED.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'VIEWER_TOP_REPLIES.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'VIEWER_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'CAMPAIGN_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'CAMPAIGN_TOP_THREAD_SOURCES.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'CAMPAIGN_TOP_CONTENT_CREATORS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'LEADERSHIP_THEME_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'NETWORK_TOP_THREAD_STARTERS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'NETWORK_TOP_THEMES.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'NETWORK_TOP_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'NETWORK_THEME_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'NETWORK_TOP_ANNOUNCEMENTS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'NETWORK_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'THREAD_EXTENDED_ACTIVITY_TOP_REPLIES.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    case 'THREAD_EXTENDED_ACTIVITY_SHARES.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });

    default:
      return state;
  }
};

export default reducer;
